import type React from 'react'

import { useAuth } from '../hooks/useAuth'
import './SlideMenu.css'

type SlideMenuLinkProps = {
  label: string
  url: string
  smallFont: boolean
  onBeforeOpen?: () => boolean // Returns false to prevent opening
}

export const SlideMenuLink: React.FC<SlideMenuLinkProps> = props => {
  const label = props.label
  const url = props.url
  const auth = useAuth()

  const handleChange = () => {
    // If false, prevent opening url
    if (props.onBeforeOpen?.() === false) {
      return
    }
    window.open(url, '_blank')
  }

  const Tag = props.smallFont ? <span className="smallFont">{label}</span> : <span>{label}</span>

  return (
    <li>
      <label className="slidein">
        <input disabled={auth.isDisable} type="radio" checked={false} onChange={handleChange} />
        {Tag}
      </label>
    </li>
  )
}
